import { useLocation } from "react-router-dom";
import ListSponsored from "../components/listSponsored/listSponsored";

export default function ListSponsoredPage() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  const url = params.get("url");
  const momios = params.get("momios");
  const patrocinador = params.get("spon");
  const version= params.get("country");

  return(
    <ListSponsored url={url} flagMomios={momios} patrocinador={patrocinador} version={version}/>
  )

}